import flatpickr from 'flatpickr';
import German from 'flatpickr/dist/l10n/de.js';
import Gator from 'gator';

// DATE PICKERS

let numberOfNights = null;

function initFlatPickr() {
    // Save number of nights in package
    const numberOfNightsEl = document.querySelector('#inquiryFormHotel [data-nights]');
    if (numberOfNightsEl) {
        numberOfNights = numberOfNightsEl.getAttribute('data-nights');
        if (numberOfNights == '') {
            numberOfNights = null;
        } else {
            numberOfNights = parseInt(numberOfNights, 10);
        }
    }

    const dateInput = document.querySelector('#daySpaForm-date');

    const arrivalInput = document.querySelector('#inquiryFormHotel-arrivalDate');
    const alternativeArrivalInput = document.querySelector('#inquiryFormHotel-alternativeArrivalDate');
    const departureInput = document.querySelector('#inquiryFormHotel-departureDate');
    const alternativeDepartureInput = document.querySelector('#inquiryFormHotel-alternativeDepartureDate');

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true,
    };

    if (!dateInput && (!arrivalInput || !departureInput || !alternativeArrivalInput || !alternativeDepartureInput)) {
        return;
    } else if (dateInput) {
        const dateFlatPickr = flatpickr(dateInput, commonOptions);
        dateInput.nextElementSibling.onkeypress = () => false;
        return;
    }

    if (numberOfNights) {
        let inputPlaceholderSingle = document.querySelector('#inquiryFormHotel #nightsLabelSingle');
        let inputPlaceholderMulti = document.querySelector('#inquiryFormHotel #nightsLabelMulti');
        if (inputPlaceholderSingle && inputPlaceholderMulti) {
            inputPlaceholderSingle = inputPlaceholderSingle.innerHTML;
            inputPlaceholderMulti = inputPlaceholderMulti.innerHTML;
            const inputPlaceholder = numberOfNights == 1 ? inputPlaceholderSingle : inputPlaceholderMulti;
            departureInput.setAttribute('placeholder', inputPlaceholder);
            alternativeDepartureInput.setAttribute('placeholder', inputPlaceholder);
        }

        departureInput.parentElement.classList.add('automatically-filled');
        departureInput.setAttribute('tabindex', '-1');
        alternativeDepartureInput.parentElement.classList.add('automatically-filled');
        alternativeDepartureInput.setAttribute('tabindex', '-1');
    }

    let minDepartureDate = arrivalInput.value ? new Date(arrivalInput.value) : null;

    const arrivalFlatPickr = flatpickr(arrivalInput, commonOptions);
    const alternativeArrivalFlatPickr = flatpickr(alternativeArrivalInput, commonOptions);
    const departureFlatPickr = flatpickr(departureInput, commonOptions);
    const alternativeDepartureFlatPickr = flatpickr(alternativeDepartureInput, commonOptions);

    if (minDepartureDate instanceof Date) {
        departureFlatPickr.config.minDate = minDepartureDate;
        alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
    }

    arrivalFlatPickr.config.onChange.push((selectedDates) => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            departureFlatPickr.config.minDate = minDepartureDate;
            if (numberOfNights) {
                departureFlatPickr.setDate(minDepartureDate.fp_incr(numberOfNights));
            }
        }
    });

    alternativeArrivalFlatPickr.config.onChange.push((selectedDates) => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
            if (numberOfNights) {
                alternativeDepartureFlatPickr.setDate(minDepartureDate.fp_incr(numberOfNights));
            }
        }
    });

    departureFlatPickr.config.onOpen.push(() => {
        if (departureFlatPickr.config.minDate instanceof Date) {
            let openDate = departureInput.value ? new Date(departureInput.value) : departureFlatPickr.config.minDate;
            departureFlatPickr.changeYear(openDate.getFullYear(), false);
            departureFlatPickr.changeMonth(openDate.getMonth(), false);
        }
    });

    alternativeDepartureFlatPickr.config.onOpen.push(() => {
        if (alternativeDepartureFlatPickr.config.minDate instanceof Date) {
            let openDate = alternativeDepartureInput.value
                ? new Date(alternativeDepartureInput.value)
                : alternativeDepartureFlatPickr.config.minDate;
            alternativeDepartureFlatPickr.changeYear(openDate.getFullYear(), false);
            alternativeDepartureFlatPickr.changeMonth(openDate.getMonth(), false);
        }
    });

    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    arrivalInput.nextElementSibling.onkeypress = () => false;
    alternativeArrivalInput.nextElementSibling.onkeypress = () => false;
    departureInput.nextElementSibling.onkeypress = () => false;
    alternativeDepartureInput.nextElementSibling.onkeypress = () => false;
}

initFlatPickr();

// CHILD AGE FIELDS

function showChildAgeFields() {
    const childAgeFields = document.querySelectorAll('.js-child-age');
    const childField = document.querySelector('.js-children');

    if (!childAgeFields || !childField) {
        return;
    }
    function removeFields() {
        const childFieldValue = parseInt(childField.value);
        if (childFieldValue && childFieldValue > 0) {
            document.querySelector('.form-heading--ages').style.display = 'block';
        } else {
            document.querySelector('.form-heading--ages').style.display = 'none';
        }

        [...childAgeFields].forEach((childAgeField, index) => {
            if (index > childFieldValue - 1 || !childFieldValue) {
                childAgeField.classList.add('input--hidden');
                childAgeField.querySelector('input').required = false;
                childAgeField.querySelector('input').value = '';
            } else {
                childAgeField.classList.remove('input--hidden');
                childAgeField.querySelector('input').required = true;
            }
        });
    }

    removeFields();

    childField.addEventListener('input', removeFields);
}

showChildAgeFields();

// ROOM SELECTOR

function insertRoomPictures() {
    let roomImages = [];
    let altTexts = {};

    // 1. Select first option per default
    const defaultInput = document.querySelector('#inquiryFormHotel-room li:first-child input');
    if (defaultInput) {
        defaultInput.checked = true;
    }

    // 2. save images in array
    const container = document.querySelector('#room-images');
    if (container) {
        const images = container.querySelectorAll('img');
        [...images].forEach((img) => {
            roomImages[img.getAttribute('data-for')] = img.getAttribute('src');
            altTexts[img.getAttribute('data-for')] = img.getAttribute('alt');
        });
    }

    // 3. insert images
    const inputs = document.querySelectorAll('.room-selector input');
    [...inputs].forEach((input) => {
        let imgEl = document.createElement('img');
        let src = roomImages[input.getAttribute('value')];
        if (src) {
            imgEl.setAttribute('src', src);
            input.parentNode.insertBefore(imgEl, input.nextSibling);
        }
        let alt = altTexts[input.getAttribute('value')];
        if (alt) {
            imgEl.setAttribute('alt', alt);
        }
    });
}

insertRoomPictures();

// Address fields are required when wantsBrochure is checked

const brochureCheckbox = document.querySelector('[type="checkbox"][name="--inquiryFormHotel[wantsBrochure]"]');
if (brochureCheckbox) {
    brochureCheckbox.addEventListener('change', function () {
        const addressFields = document.querySelectorAll(
            'label[for="inquiryFormHotel-street"],label[for="inquiryFormHotel-houseNumber"],label[for="inquiryFormHotel-postCode"],label[for="inquiryFormHotel-city"],label[for="inquiryFormHotel-country"]'
        );

        [...addressFields].forEach((field) => {
            field.parentNode.querySelector('input').required = brochureCheckbox.checked;
            if (brochureCheckbox.checked) {
                field.classList.add('is-required');
            } else {
                field.classList.remove('is-required');
            }
        });
    });
}

/*
  Study Form
*/

const studyForm = document.querySelector('.study-form');

if (studyForm) {
    const studyFormSubmit = studyForm.querySelector('button[type="submit"]');
    const allCheckboxes = studyForm.querySelectorAll('.study-form-day input');

    [...studyForm.querySelectorAll('.study-form-day')].forEach((dayEl) => {
        const checkbox = dayEl.querySelector('input');
        const selectBox = dayEl.querySelector('select');

        if (!checkbox.checked) {
            selectBox.disabled = true;
            selectBox.required = false;
            selectBox.selectedIndex = 0;

            let allUnchecked = true;
            allCheckboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    allUnchecked = false;
                }
            });
            if (allUnchecked) {
                studyFormSubmit.disabled = true;
            }
        } else {
            selectBox.disabled = false;
            selectBox.required = true;
            studyFormSubmit.disabled = false;
        }

        checkbox.addEventListener('change', () => {
            if (!checkbox.checked) {
                selectBox.disabled = true;
                selectBox.required = false;
                selectBox.selectedIndex = 0;

                let allUnchecked = true;
                allCheckboxes.forEach((checkbox) => {
                    if (checkbox.checked) {
                        allUnchecked = false;
                    }
                });
                if (allUnchecked) {
                    studyFormSubmit.disabled = true;
                }
            } else {
                selectBox.disabled = false;
                selectBox.required = true;
                studyFormSubmit.disabled = false;
            }
        });
    });
}

// More files

var currentFiles = 1;
initMoreFiles();

function initMoreFiles() {
    const wrapper = document.querySelector('.more-files-toggle');

    if (wrapper) {
        const container = wrapper.closest('.file-uploads');
        const moreBtn = wrapper.querySelector('.more-files-toggle__button--more');
        const lessBtn = wrapper.querySelector('.more-files-toggle__button--less');

        moreBtn.addEventListener('click', () => {
            currentFiles++;
            container.setAttribute('data-files', currentFiles);
            wrapper.classList.add('active');
        });
        lessBtn.addEventListener('click', () => {
            currentFiles--;
            container.setAttribute('data-files', currentFiles);
            wrapper.classList.remove('active');

            const fileToHide = currentFiles + 1;
            const inputWrappers = document.querySelectorAll(
                '.file-uploads[data-files] [data-file="' + fileToHide + '"]'
            );
            [...inputWrappers].forEach((inputWrapper) => {
                inputWrapper.querySelector('input').value = '';
                const originalText = inputWrapper.querySelector('.file-upload-filename').dataset.html;
                inputWrapper.querySelector('.file-upload-filename').innerHTML = originalText;
            });
        });
    }
}

//Fileupload

Gator(document).on('change', '.file-upload-input', function () {
    const fileList = this.files;
    let filenames = [];
    for (var i = 0; i < fileList.length; i++) {
        filenames[i] = fileList[i].name;
    }

    const filename = filenames.join(', ');
    let span = this.parentNode.querySelector('.file-upload-filename');
    let original = span.dataset.html;
    if (!original) {
        original = span.innerHTML;
        span.dataset.html = original;
    }
    span.innerHTML = filename ? filename : original;
});

const jobFormEl = document.querySelector('#job-form');
const jobOffersSelect = document.getElementById('jobApplicationForm-jobOffers');

if (jobFormEl) {
    try {
        if (jobFormEl.dataset.jobOffers) {
            const jobOffers = jobFormEl.dataset.jobOffers;
            const splitOffer = jobOffers.split(',');

            if (jobOffersSelect) {
                jobOffersSelect.innerHTML = '';
                const options = splitOffer.map((offer) => `<option value="${offer}">${offer}</option>`);
                jobOffersSelect.innerHTML = options;
            }
        }
    } catch (e) {
        console.error(e);
    }
}

function initFlatPickrForAvailableFrom() {
    const availableFromInput = document.querySelector('#jobApplicationForm-availableFrom');

    if (!availableFromInput) {
        return;
    }

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true,
    };

    if (
        !availableFromInput &&
        (!dateInput || !arrivalInput || !departureInput || !alternativeArrivalInput || !alternativeDepartureInput)
    ) {
        return;
    } else if (availableFromInput) {
        const dateFlatPickr = flatpickr(availableFromInput, commonOptions);
        availableFromInput.nextElementSibling.onkeypress = () => false;
        return;
    }
}
initFlatPickrForAvailableFrom();

// Sort Countries alphabetically
const selectCountry = document.querySelector('#inquiryFormHotel-country');

if(selectCountry) {
    sortCountries(selectCountry.getElementsByTagName('option'))
}

function sortCountries(optionFields) {
    var countryOptionArrayTop = [];
    var countryOptionArray = [];

    [...optionFields].forEach((countryOption) => {
        if(countryOption.value != 'de' && countryOption.value != 'at' && countryOption.value != 'ch') {
            countryOptionArray.push([countryOption.text, countryOption.value]);
        } else {
            countryOptionArrayTop.push([countryOption.text, countryOption.value]);
        }
        countryOption.remove();
    });
    countryOptionArray = countryOptionArrayTop.concat(countryOptionArray.sort(new Intl.Collator('de').compare));

    const selectBox = document.getElementById('inquiryFormHotel-country');
    for( var i = 0; countryOptionArray.length > i; i++) {
        selectBox.add( new Option(countryOptionArray[i][0], countryOptionArray[i][1] + ' - ' + countryOptionArray[i][0]) );

        if(i === 2){
            var disabledOption = new Option("-------------", "")
            disabledOption.disabled = true;
            selectBox.add(disabledOption)
        }       
    };
}

// Prevent negative numbers 
function preventNegativeNumbers() {
    const numberInput = document.querySelectorAll('input[type="number"]');
    
    [...numberInput].forEach((input) => {
        if(input.id == 'inquiryFormHotel-adults') {
            input.setAttribute('min', 1);
        } else {
            input.setAttribute('min', 0);
        }
    });
}
preventNegativeNumbers();

// ALTERNATIVE DATES
function enableAlternativeDates() {
    const arrivalDate = document.querySelector('#inquiryFormHotel-arrivalDate');
    const departureDate = document.querySelector('#inquiryFormHotel-departureDate');
    const alternativeDatesButton = document.querySelector('.js-alternative-dates-button');
    const alternativeDates = document.querySelector('.js-alternative-dates');

    if (!arrivalDate || !departureDate || !alternativeDatesButton || !alternativeDates) {
        return;
    }

    [arrivalDate, departureDate].forEach((dateInput) => {
        dateInput.addEventListener('change', () => {
            if (arrivalDate.value && departureDate.value) {
                alternativeDatesButton.classList.remove('inquiry-form-hotel__alternative-dates-button--hidden');
            } else {
                alternativeDatesButton.classList.add('inquiry-form-hotel__alternative-dates-button--hidden');
                alternativeDates.classList.add('inquiry-form-hotel__alternative-dates--hidden');
            }
        });
    });

    alternativeDatesButton.addEventListener('click', () => {
        alternativeDates.classList.remove('inquiry-form-hotel__alternative-dates--hidden');
    });
}
enableAlternativeDates();

// ROOM ENABLER
function enableRoomSelection(roomSelectionEnablerInput) {
    if (!roomSelectionEnablerInput) {
        return;
    }

    const roomSelection = document.querySelector('.room-selection');

    if (!roomSelection) {
        return;
    }

    const showRoomSelection = roomSelectionEnablerInput.checked && roomSelectionEnablerInput.value === '1';

    if (showRoomSelection) {
        roomSelection.classList.remove('room-selection--hidden');
    } else {
        roomSelection.classList.add('room-selection--hidden');
        const placeholderRoom = roomSelection.querySelector('input[type="radio"][value="-"]');
        const alternativeRoomSelect = roomSelection.querySelector('#inquiryFormHotel-alternativeRoom');

        if (placeholderRoom) {
            placeholderRoom.checked = true;
        }
        if (alternativeRoomSelect) {
            alternativeRoomSelect.value = '-';
        }
    }
}

[...document.querySelectorAll('.js-room-selection-enabler')].forEach((roomSelectionEnablerInput) => {
    roomSelectionEnablerInput.addEventListener('change', () => {
        enableRoomSelection(roomSelectionEnablerInput);
    });
});

// Set telephone input as required when telephoneConsultation and/or whatsAppConsent is checked
const telephoneConsultationCheckbox = document.querySelector('#inquiryFormHotel-telephoneConsultation');
const whatsAppConsentCheckbox = document.querySelector('#inquiryFormHotel-whatsappConsent');

if(telephoneConsultationCheckbox || whatsAppConsentCheckbox) {
    [telephoneConsultationCheckbox, whatsAppConsentCheckbox].forEach((checkbox) => {
        checkbox.addEventListener('click', () => {
            setTelephoneRequired();
        })
    })

    setTelephoneRequired();
}

function setTelephoneRequired() {
    const telephoneInput = document.querySelector('#inquiryFormHotel-telephone');
    
    if(telephoneConsultationCheckbox.checked || whatsAppConsentCheckbox.checked) {
        telephoneInput.required = true;
    } else {
        telephoneInput.required = false;
    }
}

// Send User-Agent, Google Client-Id, Google-Click-Id with inquiries
// Google Analytics - Cliend-Id
function get_ga_clientid() {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let splitCookie = el.split('=');
        let key = splitCookie[0].trim();
        let value = splitCookie[1];
        cookie[key] = value;
    });

    return cookie["_ga"].substring(6);
}

function set_ga_clientid() {
    const ga_input = document.querySelectorAll("[id$=-gaClientid]");

    if(ga_input) {
        ga_input.forEach((input) => {
            input.value = get_ga_clientid();
        })
    }
}

set_ga_clientid();

// Google Analytics - Google-Click-Id
function get_ga_gclid() {
    return localStorage.getItem('gclid')
}

function set_ga_gclid() {
    const gclid_input = document.querySelectorAll("[id$=-gclid_field]");

    if(gclid_input) {
        gclid_input.forEach((input) => {
            input.value = get_ga_gclid();
        })
    }
}

set_ga_gclid();

// User-Agent & Screen Size
function get_userAgent(){
    let userAgent = 'UserAgent: ' + navigator.userAgent;
    let userScreen = 'Screen: ' + window.screen.width + 'x' + window.screen.height;

    return userAgent + ', ' + userScreen;
}

function set_userAgent() {
    const userAgent_input = document.querySelectorAll("[id$=-userAgent]");

    if(userAgent_input) {
        userAgent_input.forEach((input) => {
            input.value = get_userAgent();
        })
    }
}

set_userAgent();

const daySpaForm = document.getElementById('daySpaForm');
if (daySpaForm) {
    daySpaForm.addEventListener('submit', (e) => {
        if (daySpaForm.hasAttribute('data-submitting')) {
            e.preventDefault();
            return false;
        }
        daySpaForm.setAttribute('data-submitting', '');
        trackDaySpaFormSubmit();
    });
}

function trackDaySpaFormSubmit()  {
    const persons = document.getElementById('daySpaForm-persons');
    const offers = document.getElementById('daySpaForm-offers');
    const selectedPackage = offers.options[offers.selectedIndex].text;
    const packageName = selectedPackage.split(/\(ab|\(from/)[0].trim();
    const priceMatch = selectedPackage.match(/€\s*([\d,.]+)/);
    const packagePrice = priceMatch ? priceMatch[1].replace(',', '.') : '0';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'daySpaFormSubmit',
        'numberOfPersons': parseInt(persons.value),
        'selectedPackageName': packageName,
        'selectedPackagePrice': parseFloat(packagePrice),
    });
}
